module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MP-d0fd6a45dde5ab4372c4b61ea23c8189.png";